// Mobile carousel for the "Quarterly Tea Subscription" section (sections/magazine-subscription.liquid).
// The Swiper library loads at the end of theme.liquid, after this file, so wait for it before initialising.
(function () {
    function initSubscriptionSwipers() {
        if (typeof window.Swiper === 'undefined') return false;
        if (window.innerWidth > 767) return true;

        document.querySelectorAll('.subscription__images.swiper').forEach(function (el) {
            if (el.swiper) return; // already initialised

            new Swiper(el, {
                spaceBetween: 24,
                slidesPerView: 1,
                navigation: {
                    nextEl: el.querySelector('.swiper-button-next'),
                    prevEl: el.querySelector('.swiper-button-prev')
                }
            });
        });
        return true;
    }

    if (!initSubscriptionSwipers()) {
        document.addEventListener('DOMContentLoaded', initSubscriptionSwipers);
        window.addEventListener('load', initSubscriptionSwipers);
    }
})();
